import { Helmet } from 'react-helmet-async'
import { Container } from '@mui/material';

import ACL from 'components/ACL'

import SuperUser from './SuperUser'
import Admin from './Admin'
import Seller from './Seller'
import Assistant from './Assistant'
import Legal from './Legal'
import Client from './Client'

export default function Home() {
  return (
    <>
      <Helmet>
        <title>{ process.env.REACT_APP_PROJECT_NAME }</title>
      </Helmet>

      <Container maxWidth="xl">
        <ACL profiles={['superuser']}>
          <SuperUser />
        </ACL>

        <ACL profiles={['admin']}>
          <Admin />
        </ACL>

        <ACL profiles={['seller']}>
          <Seller />
        </ACL>

        <ACL profiles={['assistant']}>
          <Assistant />
        </ACL>

        <ACL profiles={['legal']}>
          <Legal />
        </ACL>

        <ACL profiles={['client']}>
          <Client />
        </ACL>
      </Container>
    </>
  );
}
